import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { componentKey, setBlockReconciliationModal, setBlockReconciliationSuccess, setCheckForStateFrequencyPopup, setLoadingState, setPaginationState, setReconciliationGridData, setReconciliationPayerList, setReconciliationStateList, setSelectedStateWitheldPaymentFrequency, setStateWitheldPaymentFrequency } from "./ManageReconciliationFormsSlice";
import { PAGE_STATE } from "../../../constants/constants";
import ManageFormsService from "../../../../../services/ManageFormsService";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import General from "../../../../../libs/utility/General";
import { setSelectedReconciliationFormStates } from "./ManageReconciliationFormsSlice";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import ReconciliationDataService from "../../../../../services/ReconciliationDataService";
import { MANAGE_FORMS_LOADING_STATES, MANAGE_RECONCILIATION_LOADING_STATES } from "../constants";

export const { getReconPayer, getReconStatesbyPayer, getReconGridData, getReconciliationPDF, blockReconciliation, getReconFrequencyPopUpOption } = {
    getReconPayer: (payload) => {
        return {
            type: "RECONCILIATION_FORMS/GET_RECONCILIATION_PAYERS",
            payload
        }
    },

    getReconStatesbyPayer: (payload) => {
        return {
            type: "RECONCILIATION_FORMS/GET_RECONCILIATION_STATES_BY_PAYER",
            payload
        }
    },

    getReconGridData: (payload) => {
        return {
            type: "RECONCILIATION_FORMS/GET_RECONCILIATION_GRID_DATA",
            payload
        }
    },

    getReconciliationPDF: (payload) => {
        return {
            type: "RECONCILIATION_FORMS/GET_RECONCILIATION_PDF",
            payload
        }
    },

    blockReconciliation: (payload) => {
        return {
            type: "RECONCILIATION_FORMS/BLOCK_RECONCILIATION_FILING",
            payload
        }
    },

    getReconFrequencyPopUpOption: (payload) => {
        return {
            type: "RECONCILIATION_FORMS/GET_RECON_FREQUENCY_POPUP",
            payload
        }
    }
}

function* getReconPayerAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING }));

        const { urlPayerId } = action?.payload;
        const response = yield ManageFormsService.getReconciliationPayers();

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.addOptionAndValueKeys(Data, "FullName", "PayerDetailId")
            yield put(setReconciliationPayerList(Data));

            if (urlPayerId) {
                const payer = Data.find(payer => payer.PayerDetailId == urlPayerId);

                if (payer) {
                    yield put(setSelectedReconciliationFormStates({ name: "ReconciliationPayer", value: payer }))
                }
            }
        } else {
            yield put(addNotifications({ heading: "Failed to fetch the reconciliation payers", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch the reconciliation payers", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_READY }))
    }
}

function* getReconStatesbyPayerAsync(action){
    try {
        yield put(setLoadingState({ state: MANAGE_RECONCILIATION_LOADING_STATES.RECON_STATES_LOADING }));
        const {payerId, urlStateId} = action.payload;
        const response = yield ReconciliationDataService.getReconciliationStates(payerId);
        
        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.addOptionAndValueKeys(Data, "StateName", "StateAbbreviation")
            yield put(setReconciliationStateList(Data));

            if (urlStateId) {
                const state = Data.find(state => state?.value == urlStateId);

                if (state) {
                    yield put(setSelectedReconciliationFormStates({ name: "ReconciliationState", value: state }))
                }
            }
        } else {
            yield put(addNotifications({ heading: "Failed to fetch the reconciliation states", message: Message }));
        }
    }catch(error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: "We are facing some error. Please try again",
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_RECONCILIATION_LOADING_STATES.RECON_STATES_READY }));
    }
}

function* getReconGridDataAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_RECONCILIATION_LOADING_STATES.RECON_GRID_DATA_LOADING }));

        const { payerId, taxYear, state, PageNumber, PageSize } = action.payload

        const params = {
            payer: payerId,
            taxYear,
            state,
            PageNumber,
            PageSize
        }

        const response = yield ManageFormsService.getReconciliationGridData(params);

        const { Message, Status } = response?.data;
        const Data = General.extractDataFromResponseData(response?.data);

        if (Status) {
            yield put(setReconciliationGridData(Data))
            yield put(setPaginationState({ totalRecipients: General.extractPaginationTotalFromResponse(response.data) }))
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch the reconciliation data", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_RECONCILIATION_LOADING_STATES.RECON_GRID_DATA_READY }))
    }
}

function* getReconciliationPDFAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_RECONCILIATION_LOADING_STATES.RECON_GRID_DATA_LOADING }))

        const { reconFormId, reconState, formName } = action.payload

        const response = yield ManageFormsService.getReconciliationPDF({ reconFormId, reconState, formName })

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.openBase64FileInNewTab(Data.Base64, Data.Name)
        } else {
            yield put(addNotifications({ heading: "Failed to get reconciliation pdf", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to get reconciliation pdf", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_RECONCILIATION_LOADING_STATES.RECON_GRID_DATA_READY }))
    }
}

function* blockReconciliationAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_RECONCILIATION_LOADING_STATES.RECON_GRID_DATA_LOADING }));

        const { FormId, State, formName } = action.payload;

        const response = yield ManageFormsService.blockReconciliation(FormId, State, formName);

        const { Message, Status } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: "Blocked reconciliation filing Successfully", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(setBlockReconciliationSuccess(true))
            yield put(setBlockReconciliationModal(false))
        } else {
            yield put(addNotifications({ heading: "Failed to blocked reconciliation filing", message: Message }));
            yield put(setBlockReconciliationModal(false))
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to blocked state filing", message: error?.response?.data?.Message }));
        yield put(setBlockReconciliationModal(false))
    } finally {
        yield put(setLoadingState({ state: MANAGE_RECONCILIATION_LOADING_STATES.RECON_GRID_DATA_READY }))
    }
}

function* getReconFrequencyPopUpOptionAsync(action){
    try {
        yield put(setLoadingState({ state: MANAGE_RECONCILIATION_LOADING_STATES.RECON_GRID_DATA_LOADING }));
        const {state, reconFormid} = action.payload;
        const response = yield ReconciliationDataService.getReconFrequencyPopUpOption(state, reconFormid);
        if(response.data){
            if(response?.data?.Status === 0){
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }else{
                const formFrequencyOptions = response?.data?.Data.forms;
                yield put(setStateWitheldPaymentFrequency(formFrequencyOptions));
                
                let idWithFiledquarterTrue = null;
                for (const key in formFrequencyOptions) {
                    if (formFrequencyOptions.hasOwnProperty(key)) {
                        const values = formFrequencyOptions[key];
                        for (const option of values) {
                            if (option.filedquarter) {
                                idWithFiledquarterTrue = option.id;
                                break;
                            }
                        }
                    }
                }
                if(idWithFiledquarterTrue){
                    yield put(setSelectedStateWitheldPaymentFrequency(idWithFiledquarterTrue));
                }
                yield put(setCheckForStateFrequencyPopup(true));
            }
        }
    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: MANAGE_RECONCILIATION_LOADING_STATES.RECON_GRID_DATA_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getReconPayer().type, getReconPayerAsync),
        takeLatest(getReconStatesbyPayer().type, getReconStatesbyPayerAsync),
        takeLatest(getReconGridData().type, getReconGridDataAsync),
        takeLatest(getReconciliationPDF().type, getReconciliationPDFAsync),
        takeLatest(blockReconciliation().type, blockReconciliationAsync),
        takeLatest(getReconFrequencyPopUpOption().type, getReconFrequencyPopUpOptionAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);